import { Directive, Input } from '@angular/core';

import { InputSize } from './input.types';

@Directive({
  selector: '[issInput]',
  exportAs: 'issInput',
  host: { // eslint-disable-line @angular-eslint/no-host-metadata-property
    class: 'input iss-input',
    '[class.is-small]': 'size === "small"',
  },
  standalone: true,
})
export class InputDirective {
  @Input('issInputSize') public size: InputSize = 'normal';
}
